export default __webpack_public_path__ + "static/media/AkkuratProBold.ef0a21f0.woff";